import { useRef, useState, useEffect } from "react";

export const useToggle = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);

  const checkClickOutside = (e: MouseEvent) => {
    if (isOpen && ref.current && !ref.current.contains(e.target as Node)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", checkClickOutside);

    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkClickOutside);
    };

    // eslint-disable-next-line
  }, [isOpen]);

  return {
    isOpen,
    setIsOpen,
    ref,
  };
};
